// extracted by mini-css-extract-plugin
export default {"quickLink":"QuickLink_quickLink__6frVL","disableLink":"QuickLink_disableLink__4q4kf"};